import {
  PINNED_PAGES_PIN,
  PINNED_PAGES_UNPIN,
  PINNED_PAGES_GET_ALL,
  PINNED_PAGES_LS_KEY,
  PINNED_PAGES_REMOVE_ALL,
  PINNED_PAGES_SAVE_SCROLL,
} from '../constants';
import LocalStorageAsDB from '../api/services/localStorageAsDB';

const pinnedPagesDB = new LocalStorageAsDB(PINNED_PAGES_LS_KEY);

/**
 * Pin a page
 * @param {Object} pageData - Data of the page to pin
 * @param {string} pageData.pathname - Path of the page
 * @param {string} pageData.primary_image - Primary image of the page
 * @param {string} pageData.title - Title of the page
 * @returns {Function} - Redux thunk function
 */

export function pinPage({ pathname, ...pageData }) {
  return dispatch => {
    const data = pinnedPagesDB.create(pathname, pageData);

    dispatch({
      type: PINNED_PAGES_PIN,
      payload: data,
    });
  };
}

/**
 * Unpin a page
 * @param {string} pageId - ID of the page to unpin
 * @returns {Function} - Redux thunk function
 */
export function unpinPage(pageId) {
  return dispatch => {
    const data = pinnedPagesDB.delete(pageId);

    dispatch({
      type: PINNED_PAGES_UNPIN,
      payload: data,
    });
  };
}

/**
 * Get all pinned pages
 * @returns {Function} - Redux thunk function
 */
export function getAllPinnedPages() {
  return dispatch => {
    const data = pinnedPagesDB.getAll();

    dispatch({
      type: PINNED_PAGES_GET_ALL,
      payload: data,
    });
  };
}

/**
 * Remove all the pinned pages
 * @returns {Function} - Redux thunk function
 * */
export function removeAllPinnedPages() {
  return dispatch => {
    pinnedPagesDB.clear();

    dispatch({
      type: PINNED_PAGES_REMOVE_ALL,
      payload: {},
    });
  };
}

/**
 * Save scroll position for a pinned page
 * @param {string} pageId - ID of the pinned page
 * @param {Object} scrollPosition - Scroll position coordinates
 * @param {number} scrollPosition.x - Horizontal scroll position
 * @param {number} scrollPosition.y - Vertical scroll position
 * @returns {Function} - Redux thunk function
 */
export function saveScrollPosition(pageId, scrollPosition) {
  return dispatch => {
    const currentPage = pinnedPagesDB.getById(pageId);

    if (!currentPage) return;

    const payload = {
      ...currentPage,
      scrollPosition,
    };

    const data = pinnedPagesDB.update(pageId, payload);
    dispatch({
      type: PINNED_PAGES_SAVE_SCROLL,
      payload: data,
    });
  };
}
